// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sourceContainer {
    margin: auto;
    animation: fadeInGlobal 1s;
}

.sourceImageAndNameContainer {
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    /* position the top  edge of the element at the middle of the parent */
    left: 50%;
    /* position the left edge of the element at the middle of the parent */
    z-index: 1;
    transform: translate(-50%, -50%);
    height: 100%;
}

.sourceImage {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: auto;
    height: 80%;
    background-size: cover;
    animation: scaleGlobal 1s;
}

.sourceImageDisplayName {
    text-align: center;
    font-weight: 500;
    font-size: 2.8em;
    padding: 0.2em;
    border-radius: 20px;
    font-family: Impact;
    color: #fff;
    text-shadow:
        2px 0 0 #000,
        0 -2px 0 #000,
        0 2px 0 #000,
        -2px 0 0 #000;
    margin: 0;
}

.sourceImageDisplayNameContainer {
    max-height: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border-radius: 20px;
    min-width: 20em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Source/source.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,sEAAsE;IACtE,SAAS;IACT,sEAAsE;IACtE,UAAU;IACV,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX;;;;qBAIiB;IACjB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".sourceContainer {\n    margin: auto;\n    animation: fadeInGlobal 1s;\n}\n\n.sourceImageAndNameContainer {\n    max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    position: absolute;\n    top: 50%;\n    /* position the top  edge of the element at the middle of the parent */\n    left: 50%;\n    /* position the left edge of the element at the middle of the parent */\n    z-index: 1;\n    transform: translate(-50%, -50%);\n    height: 100%;\n}\n\n.sourceImage {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width: auto;\n    height: 80%;\n    background-size: cover;\n    animation: scaleGlobal 1s;\n}\n\n.sourceImageDisplayName {\n    text-align: center;\n    font-weight: 500;\n    font-size: 2.8em;\n    padding: 0.2em;\n    border-radius: 20px;\n    font-family: Impact;\n    color: #fff;\n    text-shadow:\n        2px 0 0 #000,\n        0 -2px 0 #000,\n        0 2px 0 #000,\n        -2px 0 0 #000;\n    margin: 0;\n}\n\n.sourceImageDisplayNameContainer {\n    max-height: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 20px;\n    min-width: 20em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
